import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity ShipmentHistories


export interface ShipmentHistory {
    id: ID;

    
    shipmentId: ID;

    
    key: string;

    
    action: string;

    
    contextHistory?: string;

    
    updatedAt: Date;

    
    storageId: ID;

    
    shipmentAt?: Date;

    
    cuttingId: ID;

    
    buyerId?: ID;

    
    state: ShipmentState;

    
    scopeGroupId: ID;

    
    siteId?: string;

    
    localCreatedAt: Date;

    }




export interface CreateShipmentHistory {
    
    shipmentId: ID;

    
    
    action: string;

    
    contextHistory?: string;

    
    
    
    
    
    
    
    
    
    }



export interface PresentationShipmentHistoryRequest {
    list: ListRequest,
    filter: {
        shipmentId: ID,
        shipmentIdOr: boolean,
        action: string,
        actionOr: boolean,
        shipmentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryShipmentHistory {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: ShipmentHistory): PrimaryShipmentHistory | undefined {
        return entity ? new PrimaryShipmentHistory(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryShipmentHistory {
        return new PrimaryShipmentHistory(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryShipmentHistory {
        let vals = path?.split('/');
        return new PrimaryShipmentHistory(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryShipmentHistory[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: ShipmentHistory): string {
    let fields = entity ? [
    entity.shipmentId,
            entity.action,
            ] : [];
    return fields.filter(item => item).join(' | ');
}


